import $ from 'jquery';
import formatHeadings from './formatHeadings';

export default () => {
  $(document).on('shopify:section:load', (e) => {
    formatHeadings(`[data-section-id="${e.detail.sectionId}"]`);
  });
};